import { initMarknadsinformation } from "./js/init";

document.addEventListener('DOMContentLoaded', function() {
    initMarknadsinformation();
});
